import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './FarecardAdd.css';
import './FarecardOptions.css';
import { Farecard } from '../../services/types/apitypes';
import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react';
import { uiInputMode } from '../../utils/ui';
import { isLinkInstitutionEnabled } from '../../utils/config';


type FarecardOptionsProps = {
  addValue: (f: Farecard) => void;
  passes: (f: Farecard) => void;
  convert: (f: Farecard) => void;
  autoload: (f: Farecard) => void;
  remove: (f: Farecard) => void;
  history: (f: Farecard) => void;
  lock: (f: Farecard) => void;
  cardInfo: (f: Farecard) => void;
  farecapping: (f: Farecard) => void;
  registerToInstitution: (f: Farecard) => void;
  card: Farecard;
  allowVirtual: boolean;
};

export default function FarecardOptions({
  passes,
  remove,
  autoload,
  convert,
  lock,
  history,
  addValue,
  cardInfo,
  farecapping,
  registerToInstitution,
  card,
  allowVirtual,
}: FarecardOptionsProps) {
  const [t] = useTranslation('global');

  const showLinkInstitution = isLinkInstitutionEnabled();

  return (
    <>
      <IonList
        className="farecard-options-list"
        lines="inset"
        mode={uiInputMode()}
      >
        <IonItem button detail onClick={() => passes(card)}>
          <IonIcon slot="start" src="assets/icon/card-passes.svg"></IonIcon>
          <IonLabel>{t('farecards.passes')}</IonLabel>
        </IonItem>
        <IonItem button detail onClick={() => cardInfo(card)}>
          <IonIcon slot="start" src="assets/icon/card-passes.svg"></IonIcon>
          <IonLabel>{t('farecards.information')}</IonLabel>
        </IonItem>
        <IonItem button detail onClick={() => history(card)}>
          <IonIcon slot="start" src="assets/icon/card-history.svg"></IonIcon>
          <IonLabel>{t('farecards.history')}</IonLabel>
        </IonItem>
        <IonItem button detail onClick={() => addValue(card)}>
          <IonIcon slot="start" src="assets/icon/card-add-value.svg"></IonIcon>
          <IonLabel>{t('farecards.addvalue')} </IonLabel>
        </IonItem>
        <IonItem button detail onClick={() => autoload(card)}>
          <IonIcon slot="start" src="assets/icon/card-autoload.svg"></IonIcon>
          <IonLabel>{t('farecards.autoload')}</IonLabel>
        </IonItem>
        {!card.locked && (
          <IonItem button detail onClick={() => lock(card)}>
            <IonIcon slot="start" src="assets/icon/card-lock.svg"></IonIcon>
            <IonLabel>{t('farecards.lock')}</IonLabel>
          </IonItem>
        )}
        {!card.isVirtualCard && (
          <IonItem button detail onClick={() => remove(card)}>
            <IonIcon slot="start" src="assets/icon/card-remove.svg"></IonIcon>
            <IonLabel>{t('farecards.remove')}</IonLabel>
          </IonItem>
        )}
        {!card.isVirtualCard && allowVirtual && (
          <IonItem button detail onClick={() => convert(card)}>
            <IonIcon slot="start" src="assets/icon/card-convert.svg"></IonIcon>
            <IonLabel>{t('farecards.convert')}</IonLabel>
          </IonItem>
        )}
        {showLinkInstitution && (
          <IonItem button detail onClick={() => registerToInstitution(card)}>
            <IonIcon
              style={{ color: '#2B2B2B' }}
              slot="start"
              src="assets/icon/institution.svg"
            ></IonIcon>
            <IonLabel>{t('farecards.registertoinstitution')}</IonLabel>
          </IonItem>
        )}
        {/* at the moment we'll only be having 1 pot active at the time, but this could be used in the future
        <IonItem button detail onClick={() => farecapping(card)}>
          <IonIcon slot="start" src="assets/icon/star-line.svg"></IonIcon>
          <IonLabel>{t('farecapping.title')}</IonLabel>
        </IonItem> */}
      </IonList>
    </>
  );
}
